import React from 'react';
import classnames from 'classnames';

import { Tooltip, TooltipPlacement } from 'components/common/Tooltip/Tooltip';
import { DisableReason } from 'components/employees/employeeEditPolicy';
import { getDisableReasonTooltip } from 'components/employees/getDisableReasonTooltip';
import style from './style.scss';

interface Props {
  reason?: DisableReason;
  tooltip?: string;
  children: React.ReactNode;
  className?: string;
  placement?: TooltipPlacement | string;
  dataTest?: string;
}

export const DisabledWithTooltip = ({
  reason,
  tooltip,
  children,
  className,
  placement = TooltipPlacement.top,
  dataTest,
}: Props) => {
  const message = tooltip ?? (reason ? getDisableReasonTooltip(reason) : undefined);

  if (!message) {
    return <span className={className}>{children}</span>;
  }

  return (
    <Tooltip tooltip={message} placement={placement} dataTest={dataTest}>
      <span className={classnames(style.disabledTrigger, className)}>{children}</span>
    </Tooltip>
  );
};

DisabledWithTooltip.displayName = 'DisabledWithTooltip';
